import React from 'react';
import ReportView from '../../../components/Report/ReportView';

const ReportStep = ({ formik }) => {
    const { values: reportData } = formik;

    return <ReportView reportData={reportData} />;
};

export default ReportStep;
